import TemplateView from "../TemplateView";
import messageResource from "../messageResource";
import {TypeOfWorkCategory} from "./constants";

export default class CategoryNode extends TemplateView {
    constructor(type) {
        super(null)

        this.type = type
    }

    templateHtml() {
        return '<div class="typeOfWorkCategoryNode"><%=text%>:</div>'
    }

    templateModel() {
        return {
            text: messageResource.getMessage(
                this.type === TypeOfWorkCategory.BILLABLE
                    ? 'billing_type.billable'
                    : 'billing_type.non_billable'
            ).toUpperCase()
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/typesOfWork/CategoryNode.js